import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { sanitizeHtml } from "@/lib/sanitizeHtml";
import parse from "html-react-parser";

interface SidebarCustomAdsProps {
  articleAdIds?: string[];
}

const SidebarCustomAds = ({ articleAdIds = [] }: SidebarCustomAdsProps) => {
  const { data: ads } = useQuery({
    queryKey: ['sidebar-custom-ads', articleAdIds],
    queryFn: async () => {
      let query = supabase
        .from('sidebar_ads')
        .select('id, title, html_content, position')
        .eq('is_active', true)
        .order('position', { ascending: true });

      // If article specifies specific ads, filter to those
      if (articleAdIds.length > 0) {
        query = query.in('id', articleAdIds);
      }

      const { data, error } = await query;
      if (error) throw error;
      return data;
    },
    staleTime: 5 * 60 * 1000,
  });

  if (!ads || ads.length === 0) return null;

  return (
    <>
      {ads.map((ad) => (
        <div
          key={ad.id}
          className="mx-auto w-fit max-w-full overflow-hidden rounded-lg border border-border bg-card p-0 [&_a]:block [&_img]:block [&_img]:h-auto [&_img]:max-w-full"
        >
          {parse(sanitizeHtml(ad.html_content))}
        </div>
      ))}
    </>
  );
};

export default SidebarCustomAds;
